const { pathToRegexp } = require('path-to-regexp');
const { removeSpecialCharsAndAccents } = require('../utils/url');
const { getRoutes } = require('./internalRoutes');

const URL_REGEX = '(http[s]?://)?([^/s]+/)(.*)';
const BASE_PATH = '/companies';
const ALTERNATE_PATH = '/company';

const ROUTES = getRoutes(BASE_PATH);

const changeURLtoMobile = ({ mobileProtocol, url, slug, android }) => {
  let re = new RegExp(URL_REGEX);
  const url_parts = re.exec(url);
  const protocol = mobileProtocol || url_parts[2];

  const queryString = android
    ? '?open_app=deeplink_entity_pages_from_companies'
    : '';

  //TODO: Quick fix to avoid issues with Android and entity pages
  if (android) {
    return `${protocol}/entity/${slug}${queryString}`;
  }

  return `${protocol}entity/${slug}${queryString}`;
};

const ROUTES_REGEX = Object.keys(ROUTES).reduce((acc, key) => {
  acc[key] = pathToRegexp(ROUTES[key]);
  return acc;
}, {});

const getIndustryRoute = ({ name = '', id }) =>
  `${ROUTES.industries}/${id}-${removeSpecialCharsAndAccents(
    name,
  ).toLowerCase()}`;

const EXTERNAL_LINKS = {
  brandmanager: ({ slug } = {}) =>
    slug ? `/brandmanager/${slug}` : '/brandmanager',
  teampermissions: ({ companyId } = {}) =>
    companyId ? `/teampermissions/company/${companyId}` : '/teampermissions',
  projobs: '/projobs/settings/jobwish/employer',
  preferences: {
    web: '/jobseeker-criteria/employer?backTo=companies',
    mobileNative: 'jobseeker-criteria/employer',
  },
  search: '/search/companies',
  newCompany: '/pages/new/company',
};

const getIndustrySearchPageRoute = ({ id }) => {
  const unscrambledId = id.split('.')[0];

  return `${EXTERNAL_LINKS.search}?filter.industry[]=${unscrambledId}`;
};

const COMPANIES_TO_ENTITY_PAGES_SUBPAGE_MATCHING = {
  updates: 'news',
  employees: 'employees',
  jobs: 'jobs',
};

module.exports = {
  ROUTES,
  ROUTES_REGEX,
  EXTERNAL_LINKS,
  BASE_PATH,
  ALTERNATE_PATH,
  COMPANIES_TO_ENTITY_PAGES_SUBPAGE_MATCHING,
  changeURLtoMobile,
  getIndustryRoute,
  getIndustrySearchPageRoute,
};
